import { PREVIEW_GENERATE_INFO, OPENPLATFORM_PREVIEW_INFO, PREVIEW_GETSWITCH, PREVIEW_PREVIEWINFO } from '@/config/api'
import config from '@/config'

import ajax from '@/utils/ajax'
import openAjax from '@/utils/openAjax'

import { i18n } from '@/utils/i18n'
import { freePlanErrorMsg } from './common'
const CONFIG = config
const NOT_IN_STORGE_RETRY_TIMES = 5
const RETRY_TIMEOUT = 200
const VIDEO_RETRY_TIMEOUT = 30000

const PREVIEW_GEN_STATUS = {
  'not_support': 0,
  'generating_failed': 0,
  'file_not_in_final_storage': 5,
  'generating': 10,
  'generating_started': 10,
  'generating_downloading': 15,
  'generating_downloaded': 50,
  'generating_uploading': 60,
  'generating_uploaded': 75,
  'generated': 100,
  'not_started': 0,
  'download_started': 10,
  'download_completed': 15,
  'check_started': 20,
  'check_completed': 30,
  'extract_started': 40,
  'extract_completed': 100,
  'extract_processing': 50
}

const GENERATE_MESSAGES = {
  'generating': i18n.t('preivew.generating'),
  'generating_sub': i18n.t('preivew.generating_sub'),
  'not_support': i18n.t('preivew.notSupport'),
  'extension_not_correct': i18n.t('preivew.abnormal'),
  'too_large': i18n.t('preivew.resolutionBeyond'),
  'zip_too_large': i18n.t('preivew.zipSizeBeyond'),
  'server_error': i18n.t('preivew.serviceError'),
  'unknown': i18n.t('preivew.unknown'),
  'file_deleted': i18n.t('base.deletedOrForbbiden'),
  'empty': i18n.t('preivew.abnormal'),
  'media_not_support': i18n.t('preview.unablePreviewVideo'),
  'file_not_in_final_storage': i18n.t('preview.upload.abnormalFile'),
  'failure': i18n.t('preview.failure'),
  'permission_denied': i18n.t('base.noPermission'),
  'failedLoad': i18n.t('preview.failedLoad'),
  'download': i18n.t('preview.download'),
  'reflash': i18n.t('preview.reflash'),
  'network_error': i18n.t('preview.networkError'),
  'encrypt_yiqixie': i18n.t('preview.encrypt.yiqixie'),
  ...freePlanErrorMsg
}
export default class PreviewCore {
  constructor (options) {
    this.retryTimes = 0
    this.previewTask = 0
    this.item = options.item
    this.stateChangedCallback = options.stateChangedCallback
    this.version = options.version
    this.scenario = options.scenario
    this.previewToken = options.previewToken
    this.unique_name = options.unique_name
  }

  start (kind) {
    kind = kind || this.getKind()
    this.previewFile({ kind })
  }

  destroy () {
    this.stateChangedCallback = null
    if (this.delayTimer) {
      clearTimeout(this.delayTimer)
    }
  }

  generateCallback (data) {
    if ('generatingStatus' in data) {
      this.generatingStatus = data.generatingStatus
    }

    if ('error' in data) {
      this.error = data.error
    }

    const percent = this.getPercent(data)
    const reason = this.getReason()
    const errorMessage = this.getErrorMessage(reason)

    if (this.stateChangedCallback) {
      this.stateChangedCallback(Object.assign({}, data, {
        percent,
        reason,
        errorMessage
      }))
    }
  }

  getPercent (data) {
    const { generatingStatus, progress } = data
    let percent
    if (generatingStatus === 'extract_processing' && progress) {
      percent = PREVIEW_GEN_STATUS[generatingStatus] + 50 * progress
    } else if (generatingStatus) {
      percent = PREVIEW_GEN_STATUS[generatingStatus] || 3
    }
    return percent
  }

  getReason () {
    return this.error && (this.error.representation_fail_reason || this.error.error).replace('unknown_error', 'unknown')
  }

  getErrorMessage (reason) {
    const errorStatus = this.error && this.error.status
    if (['generating_failed', 'failed'].includes(errorStatus)) {
      return this.error.error_tr_msg || GENERATE_MESSAGES[reason] || GENERATE_MESSAGES['failure']
    }
  }

  translateErrorMsg (key) {
    return GENERATE_MESSAGES[key]
  }

  markDownloadBtnClicked () {
    this.isClickedDownload = true
  }

  getKind (extension, extension_category) {
    extension = extension || this.item.extension
    extension_category = extension_category || this.item.extension_category
    if (['ydoc', 'yxls'].includes(extension)) {
      return 'yiqixie'
    } else if (['dwg'].includes(extension)) {
      return 'ocf'
    } else if (['document', 'text', 'markdown', 'cad'].includes(extension_category)) {
      return 'pdf'
    } else if (['image'].includes(extension_category)) {
      return 'image_1024'
    } else if (['video'].includes(extension_category)) {
      return 'video'
    } else if (['audio'].includes(extension_category)) {
      return 'audio'
    } else if (['ngm'].includes(extension)) {
      return 'ngm'
    } else if (['xmd'].includes(extension)) {
      return 'xmd'
    } else {
      return 'other'
    }
  }

  async getPerviewMethods () {
    let isJumpImage = false
    let isOnline = false
    let kind

    if (isJumpImage || isOnline || kind === 'zip' || this.scenario !== 'share') return Promise.resolve(false)

    const res = await ajax({
      url: PREVIEW_GETSWITCH
    })
    let isVenus = false
    if (res && res.success) {
      const { preview_enable } = res.data
      isVenus = preview_enable
    }
    return Promise.resolve(isVenus)
  }

  previewFile (options) {
    this.previewTask++

    if (!options.kind) {
      options.kind = this.getKind()
    }

    this.kind = options.kind

    // reset
    this.generateCallback({
      player: null,
      isGenerating: true,
      error: null,
      generatingStatus: '',
      kind: options.kind,
      viewer: this.getViewer(options.kind)
    })

    const fetchOptions = Object.assign({}, options, {
      wopi_enable: false
    })

    // 1表示轮询的第一个请求
    let count = 1
    // notFirst在预览降级的时候传入true，其他情况为false，因为生成预览与预览降级的整个过程认为是一个预览
    if (options.notFirst) {
      count = 2
    } else {
      count = 1
    }
    this.getPerviewMethods().then(isVenus => {
      this.fetchGenerateInfo(fetchOptions, this.previewTask, count, isVenus).then((previewInfo) => {
        if (['generated', 'extract_completed'].includes(previewInfo.status)) {
          // 如果当前后端使用的是wps预览，则会返回preview_type且值为wps
          if ('preview_type' in previewInfo && previewInfo.preview_type === 'wps') {
            this.generateCallback({
              generatingStatus: 'generated',
              isGenerating: false,
              previewInfo,
              viewer: 'wps'
            })
          } else if ('preview_platform' in previewInfo && previewInfo.preview_platform === 'changxie') {
            previewInfo.preview_url = config.imageUrl + previewInfo.preview_url
            this.generateCallback({
              generatingStatus: 'generated',
              isGenerating: false,
              previewInfo,
              viewer: 'wps'
            })
          } else if (previewInfo.format === 'pdf') {
            this.generateCallback({
              generatingStatus: 'generated',
              isGenerating: false,
              previewInfo,
              viewer: 'pdf'
            })
          } else {
            this.generateCallback({
              generatingStatus: 'generated',
              isGenerating: false,
              previewInfo
            })
          }
        } else {
          this.generateCallback({
            isGenerating: false,
            previewInfo
          })
        }
      }, (error) => {
        if (!error.status) {
          if (error.errors && error.errors.length > 0 && error.errors[0].code === 'permission_denied') {
            error = {
              status: 'generating_failed',
              representation_fail_reason: 'permission_denied'
            }
          } else if (error.errors && error.errors.external_errors && ['share_link_preview_limited', 'share_link_preview_download_limited', 'exceed_file_max_preview_size'].includes(error.errors.external_errors[0].error_code)) {
            error = {
              status: 'generating_failed',
              representation_fail_reason: error.errors.external_errors[0].error_code,
              error_tr_msg: error.errors.external_errors[0].error_tr_msg
            }
          } else if (error.errors && error.errors.length > 0) {
            const {
              code,
              msg
            } = error.errors[0]
            error = {
              status: 'generating_failed',
              representation_fail_reason: code,
              error_tr_msg: msg
            }
          } else {
            error = {
              status: 'generating_failed',
              representation_fail_reason: 'network_error'
            }
          }
        }

        this.generateCallback({
          isGenerating: false,
          error,
          generatingStatus: ''
        })
      })
    })
  }

  getViewer (kind) {
    let viewer = kind

    if (kind === 'image_1024') {
      viewer = 'image'
    } else if (kind === 'video' || kind === 'audio') {
      viewer = 'video'
    } else if (kind === 'ocf') {
      viewer = 'cad'
    } else {
      viewer = kind
    }

    return viewer
  }

  getUrlParameter (name) {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(name)
  }

  fetchGenerateInfoReq (queryArr, queryOptions, isVenus) {
    if (CONFIG.isOpenPlatformWithToken && this.previewToken) {
      let headers = { 'x-preview-token': this.previewToken }
      if (queryOptions['kind'] === 'pspdfkit') {
        queryOptions['kind'] = 'pdf_enc'
      }
      if (config.openConfig.previewUserToken) {
        queryOptions['preview_user_token'] = CONFIG.openConfig.previewUserToken
      }
      return openAjax({
        url: `${OPENPLATFORM_PREVIEW_INFO}`,
        accept_errors: ['permission_denied', 'external_errors', 'preview_access_permission_denied'],
        skipNetworkError: true,
        headers: headers,
        data: queryOptions
      })
    } else if (this.kind === 'ngm') {
      return Promise.resolve({success: true})
    } else if (this.kind === 'xmd') {
      return Promise.resolve({success: true, status: 'generated'})
    } else {
      if (queryOptions.scenario === 'share') {
        const uniqueName = this.unique_name || this.getUrlParameter('unique_name') || (config.externalShareResponse && config.externalShareResponse.process && config.externalShareResponse.process.share_link && config.externalShareResponse.process.share_link.unique_name)

        if (uniqueName) {
          queryArr.push(`unique_name=${uniqueName}`)
        }
      }
      let ajaxData = {}
      let data = {}
      let url = ''
      if (isVenus) {
        url = PREVIEW_PREVIEWINFO
        if (['collection', 'share', 'archive', 'review', 'work_flow'].includes(queryOptions.scenario)) {
          data.scene = queryOptions.scenario
        } else {
          data.scene = 'common'
        }

        // if(['version', 'feed'].includes(clickTarget)) {
        //     data.file_version_number = fv;
        //     data.file_version_id = version || null;
        // }
        if (queryOptions.scenario === 'review') {
          data.review = {
            from_review_id: queryOptions.from_review_id
          }
        }
        // if (queryOptions.scenario === 'work_flow') {
        //   const { templateId, work_flow_no } = this.props.router.location.query;
        //   data.work_flow = {
        //     work_flow_no: work_flow_no,
        //     template_id: templateId
        //   }
        // }
        queryArr.forEach(item => {
          const [key, value] = item.split('=')
          // if (queryOptions.scenario === 'collection' && key === 'process_code') {
          //     data.collection = {
          //       [key]: value
          //     }
          // } else
          if (queryOptions.scenario === 'share' && (key === 'unique_name' || key === 'is_first')) {
            data.share = {
              ...data.share,
              [key]: value === '1' ? true : value
            }
          } else if (['wps_enable', 'force_start', 'force_regenerate', 'change_mode', 'is_xp', 'wopi_enable'].includes(key)) {
            data[key] = JSON.parse(value)
          } else if (!data[key]) {
            data[key] = value
          }
        })
        delete data.scenario
        delete data.process_code
        delete data.unique_name
        ajaxData = {
          url: url,
          method: 'POST',
          data
        }
      } else {
        url = PREVIEW_GENERATE_INFO
        ajaxData = {
          url: `${url}?${queryArr.join('&')}`
        }
      }

      return ajax({
        ...ajaxData,
        accept_errors: ['permission_denied', 'external_errors', 'preview_access_permission_denied'],
        skipNetworkError: true
      }).then((json) => {
        const resJson = isVenus && json.success && json.data ? json.data : json
        return resJson
      })
    }
  }
  fetchGenerateInfo (options, taskId, repeatTimes, isVenus) {
    let queryArr = []
    const queryOptions = Object.assign({}, options)

    if (config.viewConfig.isWpsPreviewEnabled) {
      queryArr.push('wps_enable=true')
    }

    // iOS9 不支持pspdfkit
    queryOptions.kind = this.kind.replace('pdf', options.type ? options.type : 'pdf_enc')

    if (queryOptions.kind === 'other') {
      return Promise.reject({
        status: 'generating_failed',
        representation_fail_reason: 'not_support'
      })
    } else if (queryOptions.kind === 'yiqixie') {
      return this.item.is_encrypted ? Promise.reject({
        status: 'generating_failed',
        representation_fail_reason: 'encrypt_yiqixie'
      }) : Promise.resolve(true)
    }

    if (!queryOptions.file_id) {
      const { id: file_id } = this.item
      queryOptions.file_id = file_id
    }

    if (this.version) {
      queryOptions.file_version_id = this.version
    }

    if (this.scenario) {
      queryOptions.scenario = this.scenario
    }

    // 暂时只统计wps与pdf相关的预览时间
    if (repeatTimes === 1) {
      queryOptions.is_first = true
    } else {
      queryOptions.is_first = false
    }

    delete queryOptions.direction

    for (let key in queryOptions) {
      queryOptions[key] !== undefined && queryArr.push(`${key}=${queryOptions[key]}`)
    }

    return this.fetchGenerateInfoReq(queryArr, queryOptions, isVenus)
      .then((json) => {
        json.file_id = queryOptions.file_id
        if (
          queryOptions.file_id !== this.item.id ||
          queryOptions.file_version_id !== this.version ||
          taskId !== this.previewTask
        ) return
        let retryTimeout
        let generateMessage

        this.generateCallback({
          changeModeAvailable: json.change_mode_available
        })

        if (json.errors && json.errors.length > 0 && json.errors[0].code === 'preview_access_permission_denied') {
          return Promise.reject({
            status: 'generating_failed',
            representation_fail_reason: 'file_deleted'
          })
        } else if (config.is2023FreePlan && isVenus && json.errors && (json.errors.external_errors || json.errors.validation_errors)) {
          const errs = json.errors.external_errors || json.errors.validation_errors
          const { error_code } = errs[0]
          const isAdmin = config.user_info.is_admin_of_enterprise ? 'true' : 'false'
          if (['exceed_plan_download_traffic_limit', 'exceed_plan_upload_traffic_limit', 'free_plan_collab_folder_limit', 'free_plan_exceed_space_limit', 'ordinary_tip_exceed_plan_upload_traffic_limit'].includes(error_code)) {
            return Promise.reject({
              status: 'generating_failed',
              representation_fail_reason: `${error_code}_${isAdmin}`
            })
          }
          return Promise.reject(json)
        } else if (json.errors) {
          return Promise.reject(json)
        }

        if (this.kind === 'ngm') {
          // json.status = this.item.is_support_draw_edit ? 'generated' : 'generating_failed'
          // json.representation_fail_reason =this.item.is_support_draw_edit ? '' : 'file_deleted'
          // if (json.errors && json.errors.permission_denied) {
          //   json.error = {
          //     errors: [{'code': 'permission_denied'}]
          //   }
          // }
        }
        delete queryOptions.force_regenerate
        delete queryOptions.force_start
        delete queryOptions.change_mode

        if (['generated', 'extract_completed'].includes(json.status)) {
          return json
        } else if (['generating_failed', 'failed'].includes(json.status) || (this.retryTimes === NOT_IN_STORGE_RETRY_TIMES && json.status === 'file_not_in_final_storage')) {
          return Promise.reject(json)
        } else {
          if (this.kind === 'video' || this.kind === 'audio') {
            retryTimeout = VIDEO_RETRY_TIMEOUT
            if (json.media_status === 'analysing') {
              generateMessage = 'analysing'
            } else if (json.media_status === 'waiting') {
              generateMessage = 'waiting'
            } else {
              generateMessage = 'inTransformation'
            }

            // 这边的 generateMessage 没有被用过
            this.generateCallback({
              generateMessage
            })
          } else {
            retryTimeout = Math.min(Math.pow(2, this.retryTimes) * RETRY_TIMEOUT, RETRY_TIMEOUT * 10)
            this.retryTimes++

            this.generateCallback({
              generatingStatus: json.status,
              progress: json.progress
            })
          }

          return new Promise((resolve) => {
            this.delayTimer = setTimeout(() => {
              resolve(this.fetchGenerateInfo(queryOptions, taskId, ++repeatTimes, isVenus))
            }, retryTimeout)
          })
        }
      }).catch(e => {
        if (this.isClickedDownload && e.fetchError) {
          // 点击下载有可能会导致轮询中断，此时要再次主动发起
          let retryTimeout
          if (this.kind === 'video' || this.kind === 'audio') {
            retryTimeout = VIDEO_RETRY_TIMEOUT
          } else {
            retryTimeout = RETRY_TIMEOUT
          }
          return new Promise((resolve) => {
            this.delayTimer = setTimeout(() => {
              resolve(this.fetchGenerateInfo(queryOptions, taskId, ++repeatTimes, isVenus))
            }, retryTimeout)
          })
        }
        return Promise.reject(e)
      })
  }
}
